import { StyledParagraph } from './Paragraph.styles';

const Paragraph = ({ children }) => (
  <StyledParagraph>{children}</StyledParagraph>
);

export default Paragraph;
